// extracted by mini-css-extract-plugin
module.exports = {"power-backup-G":"G_power-backup-G___sjt7"};